import { Hint } from '../../hint/hint'
import styles from './booleanField.module.css'
import { useEffect, useState } from 'react'

type Props = {
    id: string
    label?: string
    value?: boolean
    defaultValue?: boolean
    optional?: boolean
    disabled?: boolean
    hint?: string
    onChange: (value?: boolean) => void
    className?: string
}

export const BooleanField = (props: Props) => {
    const { id, label, value, defaultValue = false, optional, disabled, hint, onChange, className } = props
    const [checked, setChecked] = useState<boolean>(defaultValue)

    useEffect(() => {
        value !== undefined && setChecked(value)
    }, [value])

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const newValue = e.target.checked
        setChecked(newValue)
        onChange(newValue)
    }
    
    return (
        <div className={styles.container}>
            <div className={styles.checkboxContainer}>
                <input
                    type="checkbox"
                    id={id}
                    name={id}
                    checked={checked}
                    required={!optional}
                    disabled={disabled}
                    className={`form-check-input ${styles.checkbox} ${className || ''}`}
                    onChange={handleChange}
                />
                <label htmlFor={id}>{label}</label>
            </div>
            {hint && <Hint text={hint} />}
        </div>
    )
}
